const DefinitionMapper = {
  total: 'Total amount awarded',
  perPerson: 'Sport grants awarded per person',
  competitive: 'Total amount awarded to competitive sport grants',
  demandDriven: 'Total amount awarded to demand driven sport grants',
  electionCommitments: 'Total amount awarded to sport grants as a part of election commitments',
  perSport: 'Sport grants awarded by type of sport',
};

export default DefinitionMapper;



// WEBPACK FOOTER //
// ./src/helpers/definition-mapper.js